type AccountCreationRequestData = {
  lastName: string;
  firstName: string;
  email: string;
  phone: string;
  team: string;
  projectDescription: string;
};

const accountCreationRequestData: AccountCreationRequestData = {
  email: "",
  firstName: "",
  lastName: "",
  phone: "",
  projectDescription: "",
  team: "",
};

export type { AccountCreationRequestData };

export { accountCreationRequestData };
